import React from 'react'

const NoFound = ({ title }) => <p className='flex justify-center items-center text-white text-center font-semibold pl-4 text-lg pb-2 min-h-[200px]'>{title}</p>

export default NoFound
